/**
 * LazyGTM - Lazy-loads Google Tag Manager after user interaction
 * This improves Lighthouse scores by deferring non-critical third-party scripts
 */

const GTM_ID = 'GTM-PNPBSJSP'

let gtmLoaded = false

const loadGTM = () => {
  if (gtmLoaded || typeof window === 'undefined') return
  
  gtmLoaded = true
  
  // Initialize dataLayer
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  })
  
  // Create and inject GTM script
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}&l=dataLayer`
  
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript.parentNode.insertBefore(script, firstScript)
  
  // Remove event listeners after loading
  removeEventListeners()
}

const eventListeners = []

const addEventListeners = () => {
  const events = ['scroll', 'click', 'touchstart', 'mousemove', 'keydown']
  
  events.forEach(event => {
    const handler = () => loadGTM()
    window.addEventListener(event, handler, { once: true, passive: true })
    eventListeners.push({ event, handler })
  })
}

const removeEventListeners = () => {
  eventListeners.forEach(({ event, handler }) => {
    window.removeEventListener(event, handler)
  })
  eventListeners.length = 0
}

export const initLazyGTM = () => {
  if (typeof window === 'undefined') return
  
  // Add interaction-based loading
  addEventListeners()
  
  // Fallback: Load after 4 seconds if no interaction
  setTimeout(() => {
    if (!gtmLoaded) {
      loadGTM()
    }
  }, 4000)
}

export default initLazyGTM

